module.exports = __webpack_public_path__ + "img/upper_ruffle_width.d3dccc73.png";